module.exports = "<div class=\"{{warningClass}}\" [attr.data-content]=\"getTooltipMsg()\">\n    <span class=\"text-light text-overflow\">\n        <span class=\"fa fa-ban icon-ban icon-ban-job\"></span>\n    </span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./shared/components/common/sn-warning/sn-warning.html
// module id = ./shared/components/common/sn-warning/sn-warning.html
// module chunks = 0